// extracted by mini-css-extract-plugin
module.exports = {"section":"CardSection_section__GRtJL","container":"CardSection_container__PjcX5","title":"CardSection_title__WfSL_","showMoreLink":"CardSection_showMoreLink__OED9C"};